import {
	POST_PARTY_CLAIM_REQUEST,
	POST_PARTY_CLAIM_SUCCESS,
	POST_PARTY_CLAIM_ERROR,
	SET_STOCK_PARTY_POST_CLAIM_COMPLETE,
	SET_STOCK_PARTY_PRE_CLAIM_COMPLETE,
	SET_STOCK_PARTY_STATUS_COMPLETE,
	GET_CURRENT_OR_NEXT_PARTY_REQUEST,
	GET_CURRENT_OR_NEXT_PARTY_SUCCESS,
	GET_CURRENT_OR_NEXT_PARTY_ERROR,
	GET_REFERRAL_DETAILS_REQUEST,
	GET_REFERRAL_DETAILS_SUCCESS,
	GET_REFERRAL_DETAILS_ERROR,
} from 'stash/actions/api/stockParty';

const initialState = {
	party: null,
	lastParty: null,
	isLoading: false,
	isClaimLoading: false,
	error: null,
	claimError: null,
	hasClaimed: false,
	isPostClaimComplete: false,
	isPreClaimComplete: false,
	isFromStockPartySource: false,
	partyStatus: null,
	isStatusComplete: false,
	referralDetails: null,
	isReferralLoading: false,
	referralError: null,
};

export default function stockParty(state = initialState, action) {
	switch (action.type) {
		case POST_PARTY_CLAIM_REQUEST:
			return {
				...state,
				isClaimLoading: true,
				claimError: null,
			};

		case POST_PARTY_CLAIM_SUCCESS:
			return {
				...state,
				isClaimLoading: false,
				hasClaimed: true,
				claimError: null,
			};

		case POST_PARTY_CLAIM_ERROR:
			return {
				...state,
				isClaimLoading: false,
				claimError: action.response?.error || action.error || 'Failed to claim stock',
			};

		case SET_STOCK_PARTY_POST_CLAIM_COMPLETE:
			return {
				...state,
				isPostClaimComplete: true,
			};

		case SET_STOCK_PARTY_PRE_CLAIM_COMPLETE:
			return {
				...state,
				isPreClaimComplete: true,
			};

		case SET_STOCK_PARTY_STATUS_COMPLETE:
			return {
				...state,
				isStatusComplete: true,
			};

		case GET_CURRENT_OR_NEXT_PARTY_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null,
				isFromStockPartySource: true,
			};

		case GET_CURRENT_OR_NEXT_PARTY_SUCCESS: {
			const response = action.response;
			const currentOrNext = response?.currentOrNext;
			const last = response?.last;

			let partyStatus = 'none';
			let activeParty = null;

			if (currentOrNext) {
				const now = new Date();
				const startTime = new Date(currentOrNext.startTime);
				const endTime = new Date(currentOrNext.endTime);

				if (now >= startTime && now < endTime) {
					partyStatus = 'current';
				} else if (now < startTime) {
					partyStatus = 'future';
				}
				activeParty = currentOrNext;
			} else if (last) {
				partyStatus = 'past';
			}

			return {
				...state,
				isLoading: false,
				party: activeParty,
				lastParty: last,
				partyStatus,
				error: null,
			};
		}

		case GET_CURRENT_OR_NEXT_PARTY_ERROR:
			return {
				...state,
				isLoading: false,
				error: action.response?.error || action.error || 'Failed to load current party',
				partyStatus: 'none',
				isFromStockPartySource: false,
			};

		case GET_REFERRAL_DETAILS_REQUEST:
			return {
				...state,
				isReferralLoading: true,
				referralError: null,
			};

		case GET_REFERRAL_DETAILS_SUCCESS:
			return {
				...state,
				isReferralLoading: false,
				referralDetails: action.response,
				referralError: null,
			};

		case GET_REFERRAL_DETAILS_ERROR:
			return {
				...state,
				isReferralLoading: false,
				referralDetails: null,
				referralError: action.response?.error || action.error || 'Failed to load referral details',
			};

		default:
			return state;
	}
}
